// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__2xjQ-","container":"Popup_container__2q74D","overlay":"Popup_overlay__2w18I"};